import { httpClient } from '../httpClient';
import {
  IAudioGeneration,
  CreateAudioGenerationRequest,
  UpdateAudioGenerationRequest,
  PaginatedResponse,
  AudioGenerationQuery,
  PaginationQuery
} from '@packages/global';

/**
 * 用户音频生成 API 模块
 * 处理用户音频生成管理操作
 */
export class AudioGenerationApi {
  /**
   * 获取用户音频生成分页列表（POST，强类型）
   */
  async audioGenerationPageList(queryData: PaginationQuery<AudioGenerationQuery>): Promise<PaginatedResponse<IAudioGeneration>> {
    return httpClient.post<PaginatedResponse<IAudioGeneration>>('/user/audioGenerations/page', queryData);
  }

  /**
   * 创建音频生成
   */
  async createAudioGeneration(data: CreateAudioGenerationRequest): Promise<IAudioGeneration> {
    return httpClient.post<IAudioGeneration>('/user/audioGenerations', data);
  }

  /**
   * 获取音频生成详情
   */
  async getAudioGeneration(id: string): Promise<IAudioGeneration> {
    return httpClient.get<IAudioGeneration>(`/user/audioGenerations/${id}`);
  }

  /**
   * 取消音频生成任务
   */
  async cancelAudioGeneration(id: string): Promise<{ cancelled: boolean }> {
    return httpClient.post<{ cancelled: boolean }>(`/user/audioGenerations/${id}/cancel`);
  }

  /**
   * 更新音频生成
   */
  async updateAudioGeneration(id: string, data: UpdateAudioGenerationRequest): Promise<IAudioGeneration> {
    return httpClient.put<IAudioGeneration>(`/user/audioGenerations/${id}`, data);
  }

  /**
   * 删除音频生成
   */
  async deleteAudioGeneration(id: string): Promise<void> {
    return httpClient.delete<void>(`/user/audioGenerations/${id}`);
  }
}

// 导出单例实例
export const audioGenerationApi = new AudioGenerationApi();